import _Media from "../../classes/media.js";
const Media = _Media;
function attachSourceFile(media, file) {
  if (!media || !file) {
    return media;
  }
  Object.defineProperty(media, "file", {
    value: file,
    writable: true,
    enumerable: false,
    configurable: true
  });
  return media;
}
export default (function loadMedia(project, mediaInfo) {
  try {
    let mediaFile;
    if (mediaInfo.storage === "Local Storage") {
      const URL = window.URL || window.webkitURL;
      mediaFile = mediaInfo.files[0];
      mediaInfo.type = mediaFile.type;
      mediaInfo.localPath = mediaFile.path, mediaInfo.audioPath = URL.createObjectURL(mediaFile), mediaInfo.path = mediaInfo.audioPath;
      mediaInfo.name = mediaFile.name;
    } else if (mediaInfo.storage === "Proxy RT") {
      mediaFile = mediaInfo.files[0];
      mediaInfo.type = mediaFile.type;
      mediaInfo.localPath = mediaFile.path, mediaInfo.audioPath = mediaFile.path, mediaInfo.path = "";
      mediaInfo.name = mediaFile.name;
    } else {
      mediaInfo.type = "video/mp4";
      mediaInfo.path = mediaInfo.mediaUrl;
      mediaInfo.localPath = mediaInfo.mediaUrl;
      mediaInfo.audioPath = mediaInfo.mediaUrl;
      mediaInfo.name = mediaInfo.projectName;
    }
    const media = {
      ...new Media(mediaInfo)
    };
    if (mediaFile) {
      attachSourceFile(media, mediaFile);
    }
    project.media = media;
  } catch (err) {
    console.log(err, err.message);
  } finally {
    return project;
  }
});